<template>
  <div>
    <EsProfileHeader>
      <template #profile-header>
        <div class="header-title">
          {{ parentGroup.label }}
        </div>
      </template>

      <template #profile-overview>
        <div class="columns">
          <div class="column">
            <div class="column-content">
              <div class="column-title" v-if="parentGroup.active === true">Active</div>
              <div class="column-title" v-else>Inactive</div>
              <div class="column-subtitle">Status</div>
            </div>
          </div>
          <div class="column">
            <div class="column-content">
              <div class="column-title">{{ parentGroup.locationsCount }}</div>
              <div class="column-subtitle">Locations</div>
            </div>
          </div>
          <div class="column">
            <div class="column-content">
              <div class="column-title">{{ parentGroup.lastUpdateDate | formatDate }}</div>
              <div class="column-subtitle">Last Updated</div>
            </div>
          </div>
        </div>
      </template>
    </EsProfileHeader>
    <div class="tabs-container">
      <div class="tabs no-bottom-border">
        <ul>
          <li :class="{ 'is-active': this.$route.name === 'groupProfileDetails' }">
            <router-link :to="{ name: 'groupProfileDetails' }">
              DETAILS
            </router-link>
          </li>
          <li :class="{ 'is-active': this.$route.name === 'groupLocationList' }">
            <router-link :to="{ name: 'groupLocationList' }">
              LOCATION LIST
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <router-view @updated="updated" :groupLabel="parentGroup.label"/>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
  faCheckCircle,
  faSitemap,

  faEdit,
} from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';


library.add(
  faTimes,
  faCheckCircle,
  faEdit,
  faSitemap,
);

export default {
  mixins: [BreadcrumbsManager],
  components: {
    EsProfileHeader,
  },
  data() {
    return {
      parentGroup: [],
      tempGroupId: null,
    };
  },
  async mounted() {
    if (this.$route.params.group) {
      this.parentGroup = this.$route.params.group;
    } else {
      await this.getGroupHeader();
    }
    this.setBreadcrumbs(this.parentGroup.label);
    this.setEditing();
  },
  methods: {
    async updated() {
      await this.getGroupHeader();
      this.setBreadcrumbs(this.parentGroup.label);
    },
    async getGroupHeader() {
      const { groupId } = this.$route.params;
      const res = await axios.get(`location-groups/${groupId}`);
      this.parentGroup = res.data;
    },
    toggleForm() {
      this.editing = !this.editing;
    },
    setEditing() {
      this.editing = false;
    },
    setBreadcrumbs(label) {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'groupList' } },
        { text: 'Group Profile', to: {} },
        { text: ':groupName', to: {} },
      ]);

      this.replaceBreadcrumb({
        find: ':groupName',
        replace: { text: `${label}`, to: {} },
      });
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 928px
  .tabs-container
    box-shadow: 0 4px 8px -3px #aaa
</style>
